module.exports = __webpack_public_path__ + "img/icon-appliance-default.6dec06aa.svg";